import styled, { keyframes } from "styled-components"

const pulseAnimation = keyframes`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
`;

const styles = {
    "WrapperDiv": styled.main`
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        padding: 40px 20px;
        margin: -8px;
    `,
    "ContentDiv": styled.div`
        width: fit-content;
        max-width: 600px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        // background-color: ${({ theme }) => theme.color.white};
        // padding: 60px 80px;
        border-radius: 16px;
        // box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        border: 1px solid ${({ theme }) => theme.color.grey1};
    `,
    "LogoDiv": styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        
        & > svg {
            fill: ${({ theme }) => theme.color.black};
        }
    `,
    "MaintenanceInfo": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;
        text-align: center;
    `,
    "Title": styled.h1`
        ${({ theme }) => theme.font.heading};
        color: ${({ theme }) => theme.color.black};
        margin: 0;
        font-size: 48px;
    `,
    "Subtitle": styled.h2`
        ${({ theme }) => theme.font.large_bold};
        color: ${({ theme }) => theme.color.grey4};
        margin: 0;
        font-weight: 300;
        font-size: 24px;
    `,
    "MessageDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin: 16px 0;
        text-align: center;
        
        & > p {
            ${({ theme }) => theme.font.medium};
            color: ${({ theme }) => theme.color.grey4};
            margin: 0;
            line-height: 1.6;
            text-align: center;
        }
    `,
    "InfoDiv": styled.div`
        display: flex;
        gap: 60px;
        margin-top: 20px;
        
        & > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
            
            & > h3 {
                ${({ theme }) => theme.font.medium_bold};
                color: ${({ theme }) => theme.color.black};
                margin: 0;
            }
            
            & > p {
                ${({ theme }) => theme.font.small};
                color: ${({ theme }) => theme.color.grey4};
                margin: 0;
                padding: 8px 16px;
                background-color: ${({ theme }) => theme.color.grey1};
                border-radius: 8px;
            }
        }
        
        @media (max-width: 600px) {
            flex-direction: column;
            gap: 20px;
        }
    `,
    "StatusIndicator": styled.div`
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px 24px;
        background-color: ${({ theme }) => theme.color.grey1};
        border-radius: 12px;
        border: 1px solid ${({ theme }) => theme.color.grey2};
        
        & > span {
            ${({ theme }) => theme.font.small_bold};
            color: ${({ theme }) => theme.color.grey4};
        }
    `,
    "StatusDot": styled.div`
        width: 12px;
        height: 12px;
        background-color: #ff6b6b;
        border-radius: 50%;
        animation: ${pulseAnimation} 2s infinite;
    `,
    "MaintenanceImage": styled.img`
        max-width: 100%;
        height: auto;
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        
        &:hover {
            transform: scale(1.02);
            box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
        }
        
        @media (max-width: 768px) {
            border-radius: 8px;
        }
    `,
}

export default styles
